import { Button, Image, Layout, Menu } from 'antd';
import { postApi } from 'apis';
import { LogoutIcon } from 'constants/Data';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSidebarMenuIcon } from 'utils/menuIcons';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';
import { SidebarProps } from './types';

// Global sidebar
const Sidebar: FC<SidebarProps> = (props) => {
	const { Sider } = Layout;
	const { handleSidebar, items, selectedSidebar } = props;
	const [itemsList, setItemsList] = useState(items);
	const navigate = useNavigate();

	const logoutHandler = async () => {
		try {

			const response = await postApi('/auth/logout');
			if (response?.data?.responseStatus === 200) {
				// Clear the accessToken cookie when the user logs out
				localStorage.removeItem('accessToken');
				// toastText(response?.payload?.message, 'success');
				navigate('/login');
			}
		} catch (error: any) {
			toastText(error.response.data?.message, 'error');
			localStorage.clear();
		} finally {
			localStorage.removeItem('accessToken');
		}
	};

	useEffect(() => {
		const updatedList = items?.map((item: any) => {
			const isSelected = item?.key === selectedSidebar;
			const icon =
				getSidebarMenuIcon(item.key, isSelected) ?? item.icon ?? null;
			return icon ? { ...item, icon } : item;
		});
		setItemsList(updatedList);
	}, [selectedSidebar, items]);

	return (
		<Sider
			style={{
				background: '#fff',
				maxHeight: '100%',
				height: '100%',
				overflow: 'auto',
			}}
			className={styles.sidebar}
		>
			<div className={styles.sidebar__wrapper}>
				<div>
					<div style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						// height: '50%',
						marginBottom: '1rem',
						marginTop: '2rem'
					}}>
						<Image
							src="/assets/images/med-panel.png"
							preview={false}
							alt="group"
							height={30}
						/>
					</div>

					<Menu
						mode="vertical"
						selectedKeys={[selectedSidebar]}
						defaultSelectedKeys={[selectedSidebar]}
						items={itemsList}
						onClick={handleSidebar}
						className="menu-item"
						style={{
							background: '#fff',
							padding: 0,
						}}
					/>
				</div>
				<div style={{ marginBottom: '0.5rem', padding: '1rem' }}>
					<Button
						block
						type="text"
						icon={null}
						className={"no-hover-bg"}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 8,
							paddingBottom: '0.5rem',
							paddingTop: '0.5rem'
						}}
						onClick={() => logoutHandler()}
					>
						<LogoutIcon />
						{'Logout'}
					</Button>
				</div>
			</div>
		</Sider>
	);
};

export default Sidebar;
